import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUserRole } from './UserRoleProvider';

// The assistant-prompt editor. Access is the `knowledge-manager` grant and nothing else — not a role,
// and not admin, who can grant it but has to be granted it like anyone else. What the page changes is how
// the assistant answers every agent in the network, without a deploy, so who holds it is a recorded
// decision about named people. The API enforces the same rule as the 'AssistantPrompt' capability, so this
// guard is about not showing someone a page whose every call would 403; it is not the security boundary.
const KnowledgeManagerRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isKnowledgeManager, isLoading, rolesUnknown } = useUserRole();

  // The profile lookup failed, so we don't know whether access was granted — say so rather than
  // redirect, which would read as a denial to someone who does have it.
  if (rolesUnknown) {
    return (
      <div className="page">
        <div className="page-content">
          <div className="loading-message">
            <p>We couldn't confirm your access. Please reload the page or sign in again.</p>
          </div>
        </div>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className="page">
        <div className="page-content">
          <div className="loading-message"><p>Checking access...</p></div>
        </div>
      </div>
    );
  }

  if (!isKnowledgeManager) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default KnowledgeManagerRoute;
